import { ContainerGlogal } from "@Components/ContainerGlogal"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, dimensions } from "@Constants/baseStyles"
import React from "react"
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native"
import { IconButton } from "react-native-paper"
import { Spacer } from "@Components/Space"
import { MaterialCommunityIcons } from "@expo/vector-icons"

export const SurveyFinished = ({ navigation }) => {
    const goBackHome = () => {
        navigation.navigate("Main", { screen: "Home" })
    }

    return (
        <ContainerGlogal style={{ ...styles.container }}>
            {/* <IconButton
                rippleColor={"rgba(0,0,0,0.05)"}
                onPress={() => goBackHome()}
                icon="close"
                color={"white"}
                iconColor={"white"}
                size={35}
                style={{ alignSelf: "flex-end" }}
            /> */}

            <TouchableOpacity onPress={() => goBackHome()} style={{ alignSelf: "flex-end", padding: 20 }}>
                <MaterialCommunityIcons name={"close"} size={35} color={"white"} />
            </TouchableOpacity>

            <ScrollView contentContainerStyle={{ flexGrow: 1, justifyContent: "center" }}>
                <BreeSerifText fontSize={22} textAlign="center" color={"white"}>
                    Questionnaire terminé !
                </BreeSerifText>
                <View
                    style={{
                        marginBottom: 35,
                        alignSelf: "center",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginTop: 25
                    }}
                >
                    <SvgMascotte
                        style={{ marginVertical: 10 }}
                        //width={dimensions.fullWidth / 1.3}
                        height={dimensions.fullHeight / 3}
                    />
                </View>
                <OpenSansText color={"white"} fontSize={16} textAlign="center">
                    Vous avez terminé de remplir la 1ère partie du Diagnostic Éducatif
                </OpenSansText>
                <View style={{ height: 30 }}></View>
                <OpenSansText color={"white"} fontSize={16} textAlign="center">
                    Vous allez recevoir par mail une confirmation ainsi que le lien pour l’entretien
                </OpenSansText>
                <Button
                    onPress={() => goBackHome()}
                    text="Accueil"
                    width="70%"
                    backgroundColor={"white"}
                    labelColor={baseColors.green.dark}
                />
            </ScrollView>

            <Spacer height={50} />
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        justifyContent: "center",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        // paddingTop: Platform.OS == "android" ? 80 : Constants.statusBarHeight,
        backgroundColor: baseColors.green.dark
    }
})
